@if (shouldGroupProducts) {
  <div class="card-section">
    @for (subGroupEvents of this.getAttractionEventsInSubgroupsForKey(key!); track subGroupEvents; let i = $index) {
      @if (isAttractionGroupChoice(subGroupEvents)) {
        <div class="row card-section-header">
          <div class="col-12 text-left">
            @if (this.getCountOfAttractionGroupChoice() > 1) {
              {{ 'pdp.choiceAttractions.'+getOnlyChoiceText(subGroupEvents) | cxTranslate }}
              <br/>
            }
            {{ 'pdp.choiceAttractionsHelpText' | cxTranslate }}
          </div>
        </div>
      }
      <br/>
      @for (event of subGroupEvents; track event) {
        <div>
          <div class="row" style="margin-bottom: 10px">
            <div class="col-3">
              <img [src]="getImage(event)" style="width: 100%; height: 70%" />
            </div>
            <div class="col-9">
              <!-- Raj: Commenting as non-timed attractions are not supposed to display the time factor -->
              <!-- <h2>
              {{ event.landEntry ? event.landEntryDisplayText : event.selectionFromTime + " - " +  event.selectionToTime}}
            </h2> -->
            <span>{{event.eventName}}</span>
          </div>
        </div>
      </div>
    }
    @if (i < this.getAttractionEventsInSubgroupsForKey(key!).length-1) {
      <hr>
      }
    }
  </div>
} @else {
  @if (product.attractions?.events) {
    <div class="card-section">
      @for (event of this.sortEventsByStartTimeAndLandEntry(product.attractions?.events!); track event) {
        <div>
          <div class="row" style="margin-bottom: 10px">
            <div class="col-3">
              <img [src]="getImage(event)" style="width: 100%; height: 70%" />
            </div>
            <div class="col-9">
              <h2>
                {{ event.landEntry ? event.landEntryDisplayText : event.selectionFromTime + " - " +  event.selectionToTime}}
              </h2>
              <span>{{event.eventName}}</span>
            </div>
          </div>
        </div>
      }
    </div>
  }
}

